const WHITE_MOVE_DIRECTION = [
    { dx: -1, dy: -1 },
    { dx: 1, dy: -1 },
]

const BLACK_MOVE_DIRECTION = [
    { dx: -1, dy: 1 },
    { dx: 1, dy: 1 },
]

const CAPTURE_DIRECTIONS = [
    { dx: -1, dy: -1 },
    { dx: 1, dy: -1 },
    { dx: -1, dy: 1 },
    { dx: 1, dy: 1 },
]

export function getLegalMoves(x, y, pieces, blocks, captureOnly = false) {
    const piece = getPiece(pieces, x, y)

    if (piece.promoted) {
        return getKingLegalMoves(x, y, pieces, blocks, captureOnly)
    } else {
        return getNormalLegalMoves(x, y, pieces, blocks, captureOnly)
    }
}

export function getNormalMoves(x, y, pieces, blocks) {
    const legalMoves = []
    const piece = getPiece(pieces, x, y)

    const moveDirections = piece.playerType === "white" ? WHITE_MOVE_DIRECTION : BLACK_MOVE_DIRECTION
    moveDirections.forEach(({ dx, dy }) => {
        const nextPiece = getPiece(pieces, (x + dx), (y + dy))
        if (!nextPiece) {
            const vacantBlock = getBlock(blocks, (x + dx), (y + dy))
            if (vacantBlock) legalMoves.push(vacantBlock)
        }
    })

    return legalMoves
}

export function getCaptureMoves(x, y, pieces, blocks) {
    const legalMoves = []
    const piece = getPiece(pieces, x, y)

    CAPTURE_DIRECTIONS.forEach(({ dx, dy }) => {
        const nextPiece = getPiece(pieces, (x + dx), (y + dy))
        const landingPiece = getPiece(pieces, (x + dx * 2), (y + dy * 2))
        const landingBlock = getBlock(blocks, (x + dx * 2), (y + dy * 2))

        if (areEnemies(piece, nextPiece) && landingBlock && !landingPiece) {
            legalMoves.push(landingBlock)
        }
    })

    return legalMoves;
}

function getNormalLegalMoves(x, y, pieces, blocks, captureOnly = false) {
    const legalMoves = []
    const piece = getPiece(pieces, x, y)

    if (!captureOnly) {
        const moveDirections = piece.playerType === "white" ? WHITE_MOVE_DIRECTION : BLACK_MOVE_DIRECTION
        moveDirections.forEach(({ dx, dy }) => {
            const nextPiece = getPiece(pieces, (x + dx), (y + dy))
            if (!nextPiece) {
                const vacantBlock = getBlock(blocks, (x + dx), (y + dy))
                if (vacantBlock) legalMoves.push(vacantBlock)
            }
        })
    }

    CAPTURE_DIRECTIONS.forEach(({ dx, dy }) => {
        const nextPiece = getPiece(pieces, (x + dx), (y + dy))
        const landingPiece = getPiece(pieces, (x + dx * 2), (y + dy * 2))
        const landingBlock = getBlock(blocks, (x + dx * 2), (y + dy * 2))

        if (areEnemies(piece, nextPiece) && landingBlock && !landingPiece) {
            legalMoves.push(landingBlock)
        }
    })

    return legalMoves;
}

function getKingLegalMoves(x, y, pieces, blocks, captureOnly = false) {
    const currPiece = getPiece(pieces, x, y)
    const legalMoves = []

    for (const { dx, dy } of CAPTURE_DIRECTIONS) {
        let capturedPiece = false;

        for (let i = 1; i < 9; i++) {

            const piece = getPiece(pieces, x + dx * i, y + dy * i);
            const block = getBlock(blocks, x + dx * i, y + dy * i);

            if (!block) break; // break if offboard

            if (piece) { // Block is occupied by enemy piece
                if (!capturedPiece && areEnemies(piece, currPiece)) {
                    // Found an enemy piece to capture for the next iteration
                    capturedPiece = true
                } else {
                    break;
                }
            } else { // Block is vacant
                if (capturedPiece) { // if flag is true, push the current block
                    legalMoves.push(block)
                } else {
                    if (!captureOnly) legalMoves.push(block);
                }
            }

        }
    }

    return legalMoves;
}

const getPiece = (pieces, x, y) => {
    return pieces.find(p => p.x === x && p.y === y)
}

const getBlock = (blocks, x, y) => {
    return blocks.find(b => b.x === x && b.y === y)
}

const areEnemies = (pieceOne, pieceTwo) => {
    if (!pieceOne || !pieceTwo) return false
    return (pieceOne.playerType !== pieceTwo.playerType)
}
